export default {
    title: 'Waiting Room',

    menu: {
        starDraw: 'Star Gacha',
        seedLetter: 'Seed Letter',
        task: 'Assignment',
        typing: 'Typing Battle',
        recentResult: {
            label: 'Recent Session Results',
            short: 'Recent<br/>Session Results',
        },
    },

    studentInfo: {
        gradeFormat: 'Grade {grade}',
        logoutConfirm: {
            title: 'Log Out',
            message: 'Do you want to log out?',
        },
    },

    navigation: {
        toAvatars: 'Go to Star Gacha',
        toSeedLetter: 'Go to Seed Letter',
        toRecentResult: 'Go to Recent Session Results',
    },

    languageSetting: {
        menuLabel: 'Language',
        title: 'Language Settings',
        description: 'You can select the language that helps you on the learning screen.',
    },
};
